import React from 'react';

const userAgreementContent = [
  {
    title: '一、 服务条款的确认和接纳',
    content: '「来往」的所有权和运营权归大连未来筑造科技有限公司所有。用户在使用「来往」服务时，应遵守以下条款。'
  },
  {
    title: '二、 服务内容',
    content: '「来往」是一款专注于人情往来的记录工具，帮助用户管理随礼、送礼等往来记录，支持家庭组共享。'
  },
  {
    title: '三、 用户行为规范',
    content: '用户不得利用「来往」服务从事以下行为：\n1. 违反法律法规的行为\n2. 侵犯他人隐私、肖像权、名誉权等合法权益\n3. 传播虚假信息、垃圾信息\n4. 干扰「来往」正常运行'
  },
  {
    title: '四、 账户安全',
    content: '用户应妥善保管账户信息，对账户安全负责。如发现账户异常，请及时联系我们。'
  },
  {
    title: '五、 免责声明',
    content: '「来往」不对用户在使用过程中产生的任何损失承担责任，包括但不限于数据丢失、资金损失等。'
  },
  {
    title: '六、 协议修改',
    content: '我们有权随时修改本协议，修改后的协议将在应用内公示。如您继续使用服务，视为同意修改后的协议。'
  }
];

export default function UserAgreement() {
  return (
    <div className="page-content">
      <h2 className="page-title">用户协议</h2>
      <p className="update-time">更新时间：2026年5月10日</p>

      {userAgreementContent.map((section, index) => (
        <div key={index} className="section">
          <h3 className="section-title">{section.title}</h3>
          <div className="section-content">
            {section.content.split('\n').map((line, i) => (
              line.match(/^\d+\./) ? (
                <p key={i}>{line}</p>
              ) : (
                <p key={i}>{line}</p>
              )
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}